import {
    GET_MONTHLY_SUBSCRIPTION_LOADING,
    GET_MONTHLY_SUBSCRIPTION_SUCCESS

} from '../actions/MonthlySubscriptionActions';

const initialState = {
    monthlySubscriptionData: null,
    isLoading: true,
};

const MonthlySubscriptionReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_MONTHLY_SUBSCRIPTION_SUCCESS:
            return { ...state, monthlySubscriptionData: action.data, isLoading: false };

        case GET_MONTHLY_SUBSCRIPTION_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default MonthlySubscriptionReducer;
